module.exports = __webpack_public_path__ + "img/collect_zx2.6c6ea587.png";